import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { clearCartCondition } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardResolverService {
  constructor(
    private activity_manager_svc: ActivityManagerService,
    private location: Location,
    private shopping_svc: ShoppingService
  ) {}

  resolve: ResolveFn<Observable<any>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => {
    return new Observable<any>((observer: any) => {
      this.shopping_svc.getShoppingItems().subscribe({
        // Every branch must emit: a resolver that never emits leaves the navigation
        // pending forever, and one that completes without emitting cancels it and
        // rewrites the history entry the user navigated to.
        next: (res: ShoppingCartData) => {
          if (this.activity_manager_svc.state().isValidCart(res))
            this.activity_manager_svc.clearCart(false, this.location);
          else if (clearCartCondition(res)) this.activity_manager_svc.clearCartInBackground(false);

          observer.next();
          observer.complete();
        },
        error: (err: HttpErrorResponse) => {
          observer.next();
          observer.complete();
        }
      });
    });
  };
}
